import React, { useState } from "react";
import Button from "../../common/Button";

//#region Context & State
const ScreenListItem = ({
  screen,
  handleLinkScreen,
  setScreen,
  setAlert,
  handleShow,
  handleRefreshScreen,
  updateScreen,
  removeScreen,
  locked,
  user,
  loadUser,
}) => {
  const screenStatus =
    screen.status &&
    new Date(screen.status.statusUpdatedAt).getTime() / 1000 + 90 >=
      new Date().getTime() / 1000;

  const [authLinkCode, setAuthLinkCode] = useState("");
  const [showAuthLink, setShowAuthLink] = useState(!screen.authToken);

  //#endregion

  // Get the date a location users weekly link limit resets
  const getResetDate = (recentLinks) => {
    if (recentLinks.length < 2) return null;

    // Oldest of the two recent links
    const oldestLink = new Date(recentLinks[0].timestamp);
    const resetDate = new Date(oldestLink.getTime() + 7 * 24 * 60 * 60 * 1000);

    return resetDate.toLocaleDateString(undefined, {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const onLinkClick = (event) => {
    event.preventDefault();
    event.currentTarget.blur();

    if (!authLinkCode) {
      setAlert({
        message: "Invalid Authorization Code",
        type: "error",
      });
      return;
    }

    let recentLinks = [];

    // Soft check for location users
    if (user?.role === "location" && Array.isArray(user.linkHistory)) {
      const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;

      recentLinks = user.linkHistory
        .filter((entry) => new Date(entry.timestamp).getTime() >= oneWeekAgo)
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)); 

      if (recentLinks.length >= 2) {
        const resetDate = getResetDate(recentLinks);

        setAlert({
          message: `You’ve already linked 2 screens this week. Your weekly limit will reset on ${resetDate}.`,
          type: "warning",
        });
        return;
      }
    }

    handleLinkScreen(screen, authLinkCode)
      .then((res) => {
        const updatedLinkHistory = [
          ...(user.linkHistory || []),
          {
            timestamp: new Date().toISOString(),
            screenId: screen._id,
          },
        ];

        const updatedRecentLinks = updatedLinkHistory
          .filter(
            (entry) =>
              new Date(entry.timestamp).getTime() >=
              Date.now() - 7 * 24 * 60 * 60 * 1000
          )
          .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

        const resetDate = getResetDate(updatedRecentLinks);

        if (user?.role === "location" && updatedRecentLinks.length === 2) {
          setAlert({
            message: `You've successfully linked your second screen for this week. Your weekly limit will reset on ${resetDate}.`,
            type: "success",
          });
        } else {
          setAlert({
            message: `${screen.name} has been linked!`,
            type: "success",
          });
        }
        loadUser();
        setShowAuthLink(false);

      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          "There was an error linking the screen.";
        setAlert({ message, type: "error" });
      });

    setShowAuthLink(false);
  };

  const onUnlinkClick = () => {
    updateScreen({ ...screen, authToken: null });
    setShowAuthLink(true);
    setAuthLinkCode("");
  };

  const onChange = (event) => {
    setAuthLinkCode(event.target.value);
  };

  const onUpdateClick = () => {
    handleShow();
    setScreen(screen);
  };

  const onDeleteClick = () => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete Screen: ${screen.name}?`
    );
    if (!confirmDelete) return;

    removeScreen(screen.id);
    setAlert({
      message: `Deleted Screen: ${screen.name}`,
      type: "success",
    });
  };

  const onRefreshClick = () => {
    handleRefreshScreen(screen);
    setAlert({
      message: `Screen: ${screen.name} is currently refreshing. Please wait at least 60 seconds while your screen updates.`,
      type: "success",
    });
  };

  return (
    <tr>
      <td>{screen.name}</td>
      <td>{screen.round}</td>
      {screen.location ? <td>{screen.location}</td> : <td></td>}
      <td>{screen.timeZone}</td>
      <td>{screen.language}</td>
      <td>
        <span style={{ color: screenStatus ? "green" : "red" }}>
          {screenStatus ? "Connected" : "Disconnected"}
        </span>
      </td>
      <td>{screen.createdAt}</td>
      <td>
        <div className="col-sm-8 ">
          <div className="input-group input-group-sm">
            {showAuthLink ? (
              <>
                <input
                  type="text"
                  name="authLinkCode"
                  title={`Insert Auth Link Code for Screen ${screen.round}`}
                  className="form-control"
                  placeholder="Auth Link Code"
                  value={authLinkCode}
                  onChange={onChange}
                  required={true}
                />
                <div className=" input-group-append">
                  <button
                    value="Link Screen"
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={onLinkClick}
                  >
                    <i className="fas fa-link"></i> Link
                  </button>
                </div>
              </>
            ) : (
              <Button
                action={onUnlinkClick}
                cssClasses={"btn btn-sm btn-danger"}
                content={
                  <>
                    <i className="fas fa-unlink"></i> Unlink
                  </>
                }
              />
            )}
          </div>
        </div>
      </td>
      <td>
        <div className="button-group">
          {!locked && (
            <>
              <Button
                action={onUpdateClick}
                content={<i className="fas fa-pencil-alt"></i>}
                cssClasses={"btn btn-outline-warning btn-sm"}
              />
              {user && user.role === "super-admin" && (
                <Button
                  action={onDeleteClick}
                  content={<i className="fas fa-trash-alt"></i>}
                  cssClasses={"btn btn-outline-danger btn-sm"}
                />
              )}
            </>
          )}
          <Button
            action={onRefreshClick}
            content={<i className="fas fa-sync"></i>}
            cssClasses={"btn btn-outline-info btn-sm"}
          />
        </div>
      </td>
    </tr>
  );
};

export default ScreenListItem;
